import React from 'react';
import { textStyles } from '../../../constants/textStyles';
import Button from '../../../components/Button/Button';

/**
 * Прогресс отправки заявки в банки.
 *
 * Раньше на этом месте крутился бесконечный спиннер: менеджер не понимал, идёт
 * ли отправка и сколько ещё ждать, закрывал вкладку — и сделка оставалась на
 * шаге анкеты. Проценты здесь не рисованные: считаем по фактическим ответам
 * банков, которые бэкенд помечает в заявке сразу, как банк ответил.
 */

const STATE_TEXT = {
  accepted: 'заявка принята',
  failed: 'не принял заявку',
  pending: 'ждём ответ…',
};

const STATE_COLOR = {
  accepted: '#2FA84F',
  failed: '#C6280E',
  pending: '#8E8E93',
};

const rowText = { ...textStyles.fieldLabel, fontWeight: '400' };

const SendAppealProgress = ({ open, total, banks = [], error, onRetry, onClose }) => {
  if (!open) return null;

  const answered = banks.filter((i) => i.state !== 'pending').length;
  const percent = total > 0 ? Math.min(100, Math.round((answered / total) * 100)) : 0;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 420,
          maxWidth: '90vw',
          maxHeight: '80vh',
          overflowY: 'auto',
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          display: 'grid',
          gap: 16,
        }}
      >
        <p style={textStyles.formTitle}>
          {error ? 'Отправка не завершилась' : 'Отправляем заявку в банки'}
        </p>

        {error ? (
          <p style={{ ...rowText, color: '#C6280E' }}>{error}</p>
        ) : (
          <>
            <div style={{ display: 'grid', gap: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={rowText}>
                  Ответили {answered} из {total}
                </span>
                <span style={rowText}>{percent}%</span>
              </div>
              <div style={{ height: 6, borderRadius: 3, background: '#EFEFF4' }}>
                <div
                  style={{
                    height: 6,
                    borderRadius: 3,
                    width: `${percent}%`,
                    background: '#2FA84F',
                    transition: 'width 0.3s ease',
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'grid', gap: 8 }}>
              {banks.map((item) => (
                <div
                  key={item.id}
                  style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}
                >
                  <span style={rowText}>{item.name}</span>
                  <span style={{ ...rowText, color: STATE_COLOR[item.state] }}>
                    {STATE_TEXT[item.state]}
                  </span>
                </div>
              ))}
            </div>

            <p style={{ ...rowText, fontSize: '14px', color: '#8E8E93' }}>
              Заявки уже ушли в банки. Даже если закрыть окно, сделка перейдёт на шаг
              с банками сама.
            </p>
          </>
        )}

        {error ? (
          <div style={{ display: 'flex', gap: 12 }}>
            {onRetry ? <Button fill text="Повторить отправку" onClick={onRetry} /> : null}
            <Button text="Закрыть" onClick={onClose} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SendAppealProgress;
